<template>
  <div>
    <div class="flex justify-center">
      <div class="my-8 text-gray-700 dark:text-gray-300">Or continue with</div>
    </div>

    <div class="flex flex-wrap justify-center">
      <button class="flex-1 btn--social" @click.prevent="signInWithGoogle()">
        <icon class="w-6 h-6" :path="mdiGoogle" />
      </button>
      <button class="flex-1 btn--social" @click.prevent="signInWithApple()">
        <icon class="w-6 h-6 opacity-50" :path="mdiApple" />
      </button>
      <button class="flex-1 btn--social" @click.prevent="signInWithGithub()">
        <icon class="w-6 h-6" :path="mdiGithub" />
      </button>
    </div>
  </div>
</template>

<script>
import { mdiGoogle, mdiApple, mdiGithub, mdiAccount } from "@mdi/js";
import {
  firebaseAuth,
  googleAuthProvider,
  githubAuthProvider,
} from "@/services/firebase";
import { signInWithPopup } from "firebase/auth";
export default {
  data() {
    return {
      mdiGoogle,
      mdiGithub,
      mdiApple,
      mdiAccount,
      email: "",
      password: "",
    };
  },
  methods: {
    async signInWithGoogle() {
      try {
        await signInWithPopup(firebaseAuth, googleAuthProvider);
        this.$router.push({ name: "overview" });
      } catch (error) {
        alert(error.message);
      }
    },
    signInWithApple() {
      alert("Apple ID authentication coming soon.");
    },
    async signInWithGithub() {
      try {
        await signInWithPopup(firebaseAuth, githubAuthProvider);
        this.$router.push({ name: "overview" });
      } catch (error) {
        alert(error.message);
      }
    },
  },
};
</script>

<style lang="postcss" scoped>
.btn--social {
  @apply flex justify-center bg-white dark:bg-gray-700 border dark:border-gray-600 rounded py-2 m-2 hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors duration-200;
}
</style>
